<template>
  <div class="form-container">
    <div class="form-preview__header">
      <h3 inline>{{ $t('page.formPreview.formPreview') }}</h3>
      <div class="header-right">
        <ht-switch
          v-model="validate"
          :active-text="$t('page.formPreview.validateForm')"
          :inactive-text="$t('page.formPreview.doNotVerifyForms')"
        />
        <el-button type="primary" @click="handleShowData">
          {{ $t('page.formPreview.formData') }}
        </el-button>
      </div>
    </div>
    <ht-divider />
    <div
      ref="previewForm"
      class="preview-form-container"
      :style="{
        '--marginBottom': marginBottom + 'px',
      }"
    >
      <ht-online-form
        ref="flowOnlineForm"
        class="online-form"
        :html="innerHtml"
        :data="data"
        :permission="permission"
        :freeze-info.sync="freezeInfo"
        @download-file="(files) => batchDownload(files)"
      />
    </div>
    <el-dialog
      class="data-show__dialog"
      :visible.sync="dataShow"
      :title="$t('page.formPreview.formData')"
    >
      <codemirror
        v-if="dataShow"
        v-model="dataStr"
        :options="dataStyle"
      ></codemirror>
      <el-footer>
        <el-button type="primary" size="small" @click="handleCopyData">
          {{ $t('eip.common.copy') }}
        </el-button>
        <el-button size="small" @click="dataShow = false">
          {{ $t('eip.common.copy') }}
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>
<script>
  import { batchDownload } from '@/api/base'
  import { previewDesignVue, previewDesignTemp } from '@/api/form.js'
  import { Base64 } from 'js-base64'
  import { codemirror } from 'vue-codemirror'
  import cloneDeep from 'lodash/cloneDeep'
  import 'codemirror/mode/javascript/javascript'

  import 'codemirror/lib/codemirror.css'
  import 'codemirror/theme/base16-light.css'
  export default {
    name: 'FormPreview',
    components: {
      codemirror,
    },
    props: {
      formId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        batchDownload,
        innerHtml: null,
        data: null,
        permission: null,
        validate: false,
        dataShow: false,
        dataStyle: {
          value: '',
          mode: 'javascript',
          readOnly: true,
          smartIndent: true,
          tabSize: 4,
          theme: 'base16-light',
          lineNumbers: true,
          line: true,
        },
        freezeInfo: {},
        marginBottom: 14,
      }
    },
    watch: {
      dataShow: {
        handler(val) {
          if (val) {
            var dataChang = cloneDeep(this.data)

            this.dataStr = JSON.stringify(dataChang, null, '\t')
          }
        },
        deep: true,
      },
    },
    mounted() {
      this.getFormById()
      let _this = this
      window.addEventListener('message', (e) => {
        if (e.data && e.data == 'form_data_request') {
          //表单数据传递给父页面
          window.parent.postMessage({ formData: _this.data }, '*')
        }
      })
    },
    methods: {
      getFormById() {
        if (!this.formId) {
          return
        }
        let previewFuntion =
          this.formId.indexOf('_') > -1 ? previewDesignTemp : previewDesignVue
        previewFuntion(this.formId).then((resp) => {
          const { bpmForm, data, permission } = resp
          if (bpmForm.expand) {
            this.findFreezeCol(JSON.parse(bpmForm.expand).list)
          }
          const { space } = JSON.parse(bpmForm.formSetting)
          if (space !== undefined) {
            this.marginBottom = space >= 0 ? space : 0
          }
          this.innerHtml = bpmForm.formHtml
          let formData = this.getQueryParamsFormData()
          if (formData && formData != '{}') {
            this.data = JSON.parse(formData)
          } else {
            this.data = data
          }
          // this.data = data
          this.permission = permission
          bpmForm.diyJs && this.handlerJs(bpmForm.diyJs)
          //表单数据传递给父页面
          //window.parent.postMessage({ formData: data }, '*')
        })
      },
      // 获取冻结列
      findFreezeCol(list) {
        for (let item of list) {
          if (item.ctrlType === 'subtable') {
            const obj = {}
            obj.freezeCol =
              item.freezeCol || item.freezeCol === 0
                ? item.freezeCol
                : undefined
            obj.list = []
            item.list.forEach((i, index) => {
              obj.list.push({
                name: this.$label(i.desc || i.title),
                fixed: index <= obj.freezeCol,
                show: true,
              })
            })
            // 控制label为 序号 的固定
            obj.freezeSub = item.freezeCol === 0 ? true : !!obj.freezeCol
            this.$set(this.freezeInfo, item.name, obj)
          } else {
            if (item.columns && item.columns.length) {
              this.findFreezeCol(item.columns)
            } else if (item.list && item.list.length) {
              this.findFreezeCol(item.list)
            }
          }
        }
      },
      getQueryParamsFormData() {
        let formData = ''
        const polUrls = window.location.href.split('?')
        if (polUrls[1]) {
          const arr = polUrls[1].split('&')
          if (arr) {
            arr.forEach((item) => {
              let temp = item.split('=')
              if (temp[0] == 'formData') {
                formData = temp[1]
                formData = Base64.decode(decodeURIComponent(formData))
                formData = formData.substr(0, formData.lastIndexOf('}') + 1)
                return
              }
            })
          }
        }
        return formData
      },
      handlerJs(diyJs) {
        const currentUser = this.$store.state.user
        let data = this.data
        let _this = this
        eval(diyJs)
      },
      handleShowData() {
        this.$refs.flowOnlineForm.getData(this.validate).then((resp) => {
          resp && (this.dataShow = true)
        })
      },
      handleCopyData() {
        this.$copyText(this.dataStr).then(() => {
          this.$message.success(this.$t('page.formPreview.copiedSuccessfully'))
          this.dataShow = false
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .form-container {
    min-height: 300px;
    padding: 20px;
    background: #fff;
    .form-preview__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    ::v-deep .el-main {
      .formT_box {
        .form-table {
          width: 100%;
          .sub-table-header {
            th {
              padding: 15px;
              background-color: #fafafa;
              border: 1px solid #f3f5f7;
            }
          }
          tbody tr td {
            padding: 10px 0;
            border: 1px solid #f3f5f7;
            // text-align: center;
          }
        }
      }
    }
  }
  .data-show__dialog ::v-deep {
    .el-dialog__body {
      padding: 20px;

      .el-footer {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .preview-form-container {
    ::v-deep {
      .el-form--label-top {
        .el-form-item__label {
          padding-bottom: 6px;
          font-weight: 600;
        }
      }

      .el-row {
        margin-bottom: 0;

        .el-col-24 {
          .el-main {
            padding: 0;

            .table_layout_wrap {
              margin: 0 0 var(--marginBottom) 0;

              .main-table {
                margin-bottom: 0;
              }
            }
          }
        }

        input {
          font-size: 14px;
        }

        .el-form-item.ht-form-item {
          margin-bottom: var(--marginBottom);

          .el-form-item__label {
            font-size: 14px;
            font-weight: 600;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      .el-tabs {
        margin-bottom: var(--marginBottom);
      }

      section[sunbos] {
        margin-bottom: var(--marginBottom);

        & .sun-div-container {
          margin-bottom: var(--marginBottom);
        }
      }
    }
  }
</style>
